module.exports = __webpack_public_path__ + "img/90501208tw.3ef6a058.png";